import { render, staticRenderFns } from "./InputPeopleNum.vue?vue&type=template&id=9863f04c&scoped=true"
import script from "./InputPeopleNum.vue?vue&type=script&lang=js"
export * from "./InputPeopleNum.vue?vue&type=script&lang=js"
import style0 from "./InputPeopleNum.vue?vue&type=style&index=0&id=9863f04c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9863f04c",
  null
  
)

export default component.exports